/**
 * The date a landlord received an item. For a lease agreement prospect that is
 * when an admin accepted it (sentDate), for anything else when it was created.
 */
export default function receivedDate(item: {
  created: string;
  sentDate?: string | null;
}): string;
export default function receivedDate(item: {
  created?: string;
  sentDate?: string | null;
}): string | undefined;
export default function receivedDate(item: {
  created?: string;
  sentDate?: string | null;
}): string | undefined {
  return item.sentDate ?? item.created;
}
